import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { TicketStatusKey } from "../../../helpers/Constants";
import { convertDateToHumanReadable, getDepartmentLabel, getTicketStatus } from "../../../helpers/Functions";
import providerApiService from "../../../services/api/ProviderApiService";
export default {
  name: "DetailsCard.vue",
  components: {},
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    getStatus: function getStatus(value) {
      return getTicketStatus(value);
    },
    getLastTimeUpdated: function getLastTimeUpdated(value) {
      return convertDateToHumanReadable(value, true);
    },
    getDepartment: function getDepartment(value) {
      return getDepartmentLabel(value);
    },
    reply: function reply() {
      this.$emit("reply");
    },
    closeTicket: function closeTicket() {
      var _this = this;

      this.$vs.loading();
      providerApiService.postCreateOrEditTicket({
        providerId: this.currentProvider.id,
        id: this.ticket.id,
        status: TicketStatusKey.CLOSED
      }).then(function (result) {
        _this.$vs.notify({
          text: result.message,
          color: "success",
          position: "bottom-center"
        });

        _this.ticket = result.data;
      }).finally(function () {
        return _this.$vs.loading.close();
      });
    }
  },
  props: {
    ticket: {
      type: Object,
      required: true
    }
  }
};